import getWithToken from "./base/get-with-token";

const getPressureOverview = (query = {}) =>
  getWithToken("/pressure/overview")(query);

export default getPressureOverview;
